<!---->
<template>
   <van-popup v-model="showTips" closeable  @close="closeHandler" :style="{width:'75%',maxHeight:'5.4rem',overflow:'hidden',borderRadius: '8px'}"
  position="center" >
    <div class="tips-wrap">
      <div class="tips">资产说明</div>
      <div class="content-wrap">
        <div class="content" v-for="item in content">
          <div class="title">{{ item.title }}</div>
          <div class="text" v-for="text in item.text">{{ text }}</div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
  export default {
    name:'tips',
    props:{
        content:{
            type:Array
        },
    },
    data() {
      return {
        showTips:false,
      }
    },
    methods: {
      closeHandler(){
        this.showTips = false;
        this.$emit("closeTips");
      }
    },
    created() {
      
    }
  }
</script>

<style scoped lang='scss'>
    .tips-wrap {
        padding: 0.24rem 0;
        max-height: 5.4rem;
        box-sizing: border-box;
        // overflow:hidden;
        .tips {
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 0.18rem;
            color: #333333;
            line-height: 0.25rem;
            text-align: center;
            font-style: normal;
            height: 0.25rem;
        }
        .content-wrap {
          max-height: calc(5.4rem - 0.49rem);
          overflow-y: auto;
          padding-left: 0.16rem;
          padding-right: 0.16rem;
        }
        .content-wrap::-webkit-scrollbar {
            width: 0em;
            display: none;
        }
        .content{

            border-bottom: 1px solid #EEEEEE;
            padding-bottom:0.08rem;
            
            .title{
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 0.15rem;
                color: #E12817;
                line-height: 0.21rem;
                text-align: left;
                font-style: normal;
                margin-top: 0.08rem;
                margin-bottom: 0.08rem;
            }
            .text {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 0.13rem;
                color: #999999;
                line-height: 0.24rem;
                text-align: justify;
                font-style: normal;
            }
          &:last-child {
            border-bottom: none;
            padding-bottom: 0.24rem;
          }
        }
    }
</style>